import React, { useEffect, useState } from 'react';

import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';
import StoreWhite from '../../../img/store-white.svg';
import HighPriory from '../../../img/priority_high.svg';
import SearchIcon from '../../../img/search-icon.svg';
import VerifiedWhite from '../../../img/verified-white.svg';
import DoneWhite from '../../../img/done_white.svg';
import api from '../../../services/api';
import { Invoice, Transacao } from '../../../model/model';

import momentTZ from 'moment-timezone';

interface ModalProps {
	modalVisible: boolean;
	setModalVisible(b: boolean): void;
	transacao: Transacao;
}

export default function PagamentoDetalhes(props: ModalProps) {
	const { modalVisible, setModalVisible, transacao } = props;

	const [showScroll, setShowScroll] = useState(false);

	const [clienteVinculado, setClienteVinculado] = useState(true);
	const [clienteCheck, setClientCheck] = useState(false);
	const [faturaVinculada, setFaturaVinculada] = useState(false);

	const [clienteInput, setClientInput] = useState('');
	const [faturaInput, setFaturaInput] = useState('');
	const [faturaSearch, setFaturaSearch] = useState('');
	const [invoices, setInvoices] = useState<Invoice[]>([]);

	const [uc, setUc] = useState('-');

	const [selectedInvoices, setSelectectedInvoices] = useState<number[]>([]);

	const [faturasVinculadas, setFaturasVinculadas] = useState<Invoice[]>([]);

	const statuses = [
		'Processando',
		'Processado',
		'Cancelado',
		'Falha',
		'Chargeback',
		'Suspeito'		
	];

	function removerFaturaVinculada(f_id: number) {
		const faturasVinc = [...faturasVinculadas];
		const indexVinc = faturasVinc.findIndex((fv) => fv.FATURA_ID === f_id);
		if (indexVinc !== -1) {
			faturasVinc.splice(indexVinc, 1);
		}

		setFaturasVinculadas([...faturasVinc]);
	}

	function setarFaturaVinculada() {
		const filter = invoices.filter((inv) =>
			selectedInvoices.includes(inv.FATURA_ID)
		);
		if (filter && filter.length > 0) {
			setFaturasVinculadas([...filter, ...faturasVinculadas]);
			setSelectectedInvoices([]);
		} else {
			setFaturasVinculadas([]);
		}
	}

	function getStatusColor() {
		const data = [
			{ label: '', color: '', value: -1 },
			{ label: 'Processando', color: '#1588D1', value: 0 },
			{ label: 'Em andamento', color: '#7CB342', value: 1 },
			{ label: 'Cancelado', color: '#757575', value: 2 },
			{ label: 'Falha', color: '#E53935', value: 3 },
			{ label: 'Pendente', color: '#7CB342', value: 4 },
			{ label: 'Completo', color: '#7CB342', value: 5 },
			{ label: 'Em conflito', color: '#FFBB33', value: 7 },
			{ label: 'CHARGEBACK', color: '#5E35B1', value: 8 },
			{ label: 'Rejeitado', color: '#757575', value: 9 },
			{ label: 'Restrito', color: '#757575', value: 11 },
			{ label: 'Registrado', color: '#7CB342', value: 12 },
		];

		const f = data.find((d) => d.value === transacao?.status);
		if (f) {
			return f.color;
		}
		return '#676767';
	}

	const tipos = ['Débito', 'Crédito', 'Dinheiro'];

	function renderMoney(value: any) {
		value = parseFloat(value);
		return value.toLocaleString('pt-BR', {
			minimumFractionDigits: 2,
			style: 'currency',
			currency: 'BRL',
		});
	}

	function handleScroll() {
		if (showScroll === false) {
			setShowScroll(true);

			setTimeout(() => {
				setShowScroll(false);
			}, 2000);
		}
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll, true);
	}, []);

	const [showModal, setShowModal] = useState(false);

	useEffect(() => {
		setShowModal(modalVisible);
		if (!modalVisible) {
			if (transacao.pagamento !== null) {
				setClienteVinculado(true);
				setFaturaVinculada(true);
			} else {
				setClienteVinculado(false);
				setFaturaVinculada(false);
			}
			setClientCheck(false);
			setFaturaVinculada(false);
			setClientInput('');
			setFaturaInput('');
			setInvoices([]);
			setUc('-');
			setFaturaSearch('');
			setInvoices([]);
			setSelectectedInvoices([]);
			setFaturasVinculadas([]);
		} else {
			if (transacao.pagamento !== null) {
				setClienteVinculado(true);
				setFaturaVinculada(true);

				loadInvoices(transacao.pagamento.uc);
			} else {
				setClienteVinculado(false);
				setFaturaVinculada(false);
			}
		}
	}, [modalVisible]);

	useEffect(() => {
		if (transacao.pagamento !== null) {
			setClienteVinculado(true);
			setFaturaVinculada(true);
		} else {
			setClienteVinculado(false);
			setFaturaVinculada(false);
		}
	}, [transacao]);

	function formatDoc() {
		let value = transacao?.doc;
		value = value.replace(/\D/g, '');
		if (value.length <= 11) {
			value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
		} else {
			value = value.replace(
				/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
				'$1.$2.$3/$4-$5'
			);
		}
		return value;
	}

	async function loadInvoices(uc: string) {
		try {
			const response = await api.get(`/admin/ws/ref/${uc}/invoices`);
			if (response.data && response.data.length > 0) {
				setUc(uc);
				setInvoices([...response.data]);
			} else {
				setInvoices([]);
			}
		} catch (error) {
			console.log(error);
		}
	}

	async function getInvoices(uc: string) {
		try {
			const response = await api.get(`/admin/ws/ref/${uc}/invoices`);
			if (response.data && response.data.length > 0) {
				setUc(uc);
				setInvoices([...response.data]);
				setClienteVinculado(true);
				setClientCheck(true);
			} else {
				setInvoices([]);
			}
		} catch (error) {
			console.log(error);
		}
	}

	function setInvoiceList(f_id: number) {
		const si = [...selectedInvoices];

		const index = si.findIndex((si) => si === f_id);

		if (index !== -1) {
			console.log(f_id);

			si.splice(index, 1);
		} else {
			si.push(f_id);
		}

		setSelectectedInvoices([...si]);
	}

	function searchUcDoc(s: string) {
		getInvoices(s);
	}

	function CalcularVinculadas() {
		let t = 0;
		if (faturasVinculadas.length > 0) {
			faturasVinculadas.forEach((fv) => {
				t = t + parseFloat(fv.C1_TOTAL_CORRIGIDO);
			});
		}

		return `${t}`;
	}

	function VinculadasValorRestanteStyled() {
		const res = VinculadasValorRestante();
		if (res > 0) {
			return `+ ${renderMoney(res.toString())}`;
		} else if (res === 0) {
			return `${renderMoney(res.toString())}`;
		} else {
			return `- ${renderMoney(Math.abs(res).toString())}`;
		}
	}

	function VinculadasValorRestante() {
		const cv = parseFloat(CalcularVinculadas());
		const tv = parseFloat(transacao.valor);
		const res = cv - tv;
		return res;
	}

	function FaturaVinculadaTooltipText() {
		if (faturasVinculadas.length > 0) {
			return `O valor total pago não corresponde à soma do valor total de faturas. ${
				VinculadasValorRestante() > 0 ? 'Excedem por' : 'Faltam'
			} `;
		} else return 'Nenhuma fatura vinculada';
	}

	return (
		<Modal
			fullscreen
			dialogClassName='hide-this-modal'
			centered={false}
			animation={false}
			show={modalVisible}
			onHide={() => {
				setModalVisible(false);
			}}>
			<Modal.Body>
				<div
					onClick={(e) => {
						e.preventDefault();
						setModalVisible(false);
					}}
					style={{
						position: 'fixed',
						height: '100vh',
						width: '100vw',
						top: 0,
						left: 0,
						display: 'flex',
						justifyContent: 'flex-end',
					}}>
					<ModalMainContainer
						visible={showModal}
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}>
						<ModalHeader>
							<HeaderTitle>{'Detalhes do pagamento3'}</HeaderTitle>

							{transacao.pagamento ? (
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<HeaderButton
										onClick={(e) => {
											e.preventDefault();
											setModalVisible(false);
										}}
										style={{ background: '#28A745', color: '#FFFFFF' }}>
										Fechar
									</HeaderButton>
								</div>
							) : (
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
									}}>
									<HeaderButton
										onClick={(e) => {
											e.preventDefault();
											setModalVisible(false);
										}}
										style={{ background: 'transparent', color: '#676767' }}>
										Cancelar
									</HeaderButton>
									<HeaderButton
										disabled={VinculadasValorRestante() !== 0}
										onClick={(e) => {
											e.preventDefault();
											setModalVisible(false);
										}}
										style={
											VinculadasValorRestante() === 0
												? { background: '#28A745', color: '#FFFFFF' }
												: { background: '#F0F0F0', color: '#9F9F9F' }
										}>
										Salvar
									</HeaderButton>
								</div>
							)}
						</ModalHeader>
						<ModalContainer showScroll={showScroll}>
							<BodyMenu>
								{clienteVinculado ? (
									<MenuItem showChecked={clienteCheck}>
										<p className='menu_item_title menu_margin_b-8'>Cliente</p>

										<div className='menu_margin_b-16'>
											<p className='menu_item_label menu_margin_b-2'>nome</p>
											<p className='menu_item_info'>{transacao?.cliente}</p>
										</div>

										<div
											className={clienteCheck ? 'menu_margin_b-16' : ''}
											style={{
												flexDirection: 'row',
												display: 'flex',
												alignItems: 'center',
											}}>
											<div style={{ marginRight: 25 }}>
												<p className='menu_item_label menu_margin_b-2'>UC</p>
												<p className='menu_item_info'>
													{transacao.pagamento ? transacao.pagamento.uc : uc}
												</p>
											</div>
											<div>
												<p className='menu_item_label menu_margin_b-8=2'>
													documento
												</p>
												<p className='menu_item_info'>{formatDoc()}</p>
											</div>
										</div>

										{clienteCheck && (
											<form
												onSubmit={(e) => {
													e.preventDefault();
													searchUcDoc(clienteInput);
												}}
												className='menu_input_container'>
												{clienteInput.length === 0 && (
													<img
														style={{ width: 12, height: 12 }}
														alt='search'
														src={SearchIcon}
													/>
												)}
												<input
													type='text'
													value={clienteInput}
													onChange={(e) => {
														setClientInput(e.target.value);
													}}
													placeholder='Buscar por UC ou documento'
												/>
												{clienteInput.length > 0 && (
													<button
														type='submit'
														onClick={(e) => {
															e.preventDefault();
															searchUcDoc(clienteInput);
														}}
														className='menu_search_button'>
														Buscar
													</button>
												)}
											</form>
										)}

										<OverlayTrigger
											key={'1'}
											placement='left'
											overlay={
												<Tooltip id='menu_tool_tip'>
													<span style={{ textTransform: 'capitalize' }}>
														Cliente vinculado
													</span>
												</Tooltip>
											}>
											<div className='menu_top_fixed_tr_checked'>
												<img alt='v' src={VerifiedWhite} />
											</div>
										</OverlayTrigger>
									</MenuItem>
								) : (
									<MenuItem showWarning={true}>
										<p className='menu_item_title menu_margin_b-32'>
											Vincular cliente
										</p>

										<form
											onSubmit={(e) => {
												e.preventDefault();
												searchUcDoc(clienteInput);
											}}
											className='menu_input_container'>
											{clienteInput.length === 0 && (
												<img
													style={{ width: 12, height: 12 }}
													alt='search'
													src={SearchIcon}
												/>
											)}
											<input
												type='text'
												value={clienteInput}
												onChange={(e) => {
													setClientInput(e.target.value);
												}}
												placeholder='Buscar por UC ou documento'
											/>
											{clienteInput.length > 0 && (
												<button
													type='button'
													onClick={(e) => {
														console.log('ello');
														e.preventDefault();
														searchUcDoc(clienteInput);
													}}
													className='menu_search_button'>
													Buscar
												</button>
											)}
										</form>

										<OverlayTrigger
											key={'1'}
											placement='left'
											overlay={
												<Tooltip id='menu_tool_tip'>
													<span style={{ textTransform: 'capitalize' }}>
														nenhum cliente vinculado
													</span>
												</Tooltip>
											}>
											<div
												onClick={(e) => {
													e.preventDefault();
												}}
												className='menu_top_fixed_tr'>
												<img alt='!' src={HighPriory} />
											</div>
										</OverlayTrigger>
									</MenuItem>
								)}
								<MenuItem>
									<div
										className='menu_margin_b-20'
										style={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<p className='menu_item_title'>Pagamento </p>
										<div
											style={{
												background: getStatusColor(),
											}}
											className='menu_item_status'>
											{statuses[transacao?.status]}
										</div>
									</div>
									<div
										className='menu_margin_b-16'
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}>
										<p className='menu_item_label'>total pago</p>
										<p className='menu_item_heavy'>
											{renderMoney(transacao?.valor)}
										</p>
									</div>

									<div
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											alignItems: 'center',
										}}>
										<p className='menu_item_label'>Criado em</p>
										<p className='menu_item_info'>
											{momentTZ
												.tz(transacao?.cadastro, 'America/Sao_Paulo')
												.format('DD/MM/YYYY HH:mm:ss')}
										</p>
									</div>
								</MenuItem>

								<MenuItem>
									<p className='menu_item_title menu_margin_b-8'>
										Ponto de Venda
									</p>

									<div
										className='menu_margin_b-16'
										style={{
											flexDirection: 'row',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'space-between',
										}}>
										<div>
											<p className='menu_item_label menu_margin_b-2'>
												nome da loja
											</p>
											<p className='menu_item_info'>
												{transacao?.pontoVenda.unidade.nome
													? transacao.pontoVenda.unidade.nome
													: '-'}
											</p>
										</div>
										<div>
											<p className='menu_item_label menu_margin_b-2'>
												Identificador
											</p>
											<p className='menu_item_info'>
												{transacao?.pontoVenda
													? transacao?.pontoVenda.apelido.toUpperCase()
													: '-'}
											</p>
										</div>
									</div>
									<div>
										<p className='menu_item_label menu_margin_b-2'>Cidade</p>
										<p className='menu_item_info'>
											{transacao?.pontoVenda.unidade.cidade
												? transacao?.pontoVenda.unidade.cidade
												: '-'}
										</p>
									</div>

									<OverlayTrigger
										key={'1'}
										placement='left'
										overlay={
											<Tooltip id='menu_tool_tip'>
												<span style={{ textTransform: 'capitalize' }}>
													item local
												</span>
											</Tooltip>
										}>
										<div className='menu_bottom_fixed_br'>
											<img alt='store' src={StoreWhite} />
										</div>
									</OverlayTrigger>
								</MenuItem>

								<MenuItem>
									<p className='menu_item_title menu_margin_b-8'>Ajuri</p>

									<div
										style={{
											flexDirection: 'row',
											display: 'flex',
											alignItems: 'center',
										}}>
										<div style={{ marginRight: 25 }}>
											<p className='menu_item_label menu_margin_b-2'>
												Identificador
											</p>
											<p className='menu_item_info'>
												{`transacao?.identificador || '-'`}
											</p>
										</div>
										<div>
											<p className='menu_item_label menu_margin_b-8=2'>cupom</p>
											<p className='menu_item_info'>
												{`transacao?.cupom || '-'`}
											</p>
										</div>
									</div>
								</MenuItem>

								{<div style={{ background: 'transparent', padding: 10 }} />}
							</BodyMenu>
							<BodyMenu style={{ marginLeft: 16 }}>
								<MenuItem>
									<p className='menu_item_title menu_margin_b-8'>
										Detalhes da transação
									</p>

									<div className={''}>
										<div
											className='menu_margin_b-16'
											style={{
												flexDirection: 'row',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}>
											<div>
												<p className='menu_item_label menu_margin_b-2'>Tipo</p>
												<p className='menu_item_info'>
													{tipos[parseInt(transacao.tipo)]} (
													{transacao.parcelas ? transacao.parcelas : '1'}x)
												</p>
											</div>
											<div>
												<p className='menu_item_label menu_margin_b-8=2'>
													Valor
												</p>
												<p className='menu_item_info'>
													{renderMoney(transacao.valor)}
												</p>
											</div>
										</div>
										<div
											style={{
												flexDirection: 'row',
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}>
											<div>
												<p className='menu_item_label menu_margin_b-2'>Pan</p>
												<p className='menu_item_info'>{transacao.pan}</p>
											</div>
											<div>
												<p className='menu_item_label menu_margin_b-8=2'>NSU</p>
												<p className='menu_item_info'>{transacao.atk || '-'}</p>
											</div>
										</div>
									</div>
								</MenuItem>
								{faturaVinculada ? (
									<MenuItem>
										<p
											style={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
											}}
											className='menu_item_title menu_margin_b-8'>
											Faturas Pagas{' '}
											<span
												style={{
													color: '#FFFFFF',
													marginLeft: 8,
													fontSize: 13,
												}}
												className='menu_circle'>
												{invoices.length || 0}
											</span>
										</p>
										<table>
											<thead>
												<tr className=''>
													<th className='menu_item_label menu_padding_b-16'>
														Fatura
													</th>
													<th className='menu_item_label menu_padding_b-16'>
														Vencimento
													</th>
													<th className='menu_item_label float_right menu_padding_b-16'>
														Valor
													</th>
												</tr>
											</thead>
											<tbody>
												{invoices.map((inv) => {
													return (
														<tr className='' key={inv.FATURA_ID}>
															<td className='menu_item_info_bold menu_padding_b-16'>
																{inv.DT_REF_EDT}
																{parseInt(inv.FD) > 0 ? ' - ' + inv.FD : ''}
															</td>
															<td className='menu_item_info_regular menu_padding_b-16'>
																{inv.DT_VENCIMENTO_EDT}
															</td>
															<td className='menu_item_info_bold float_right menu_padding_b-16'>
																{renderMoney(inv.C1_TOTAL_CORRIGIDO)}
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>

										<OverlayTrigger
											key={'1'}
											placement='left'
											overlay={
												<Tooltip id='menu_tool_tip'>
													<span style={{ textTransform: 'capitalize' }}>
														{FaturaVinculadaTooltipText()}
														{VinculadasValorRestante() !== 0 && (
															<span style={{ fontWeight: 'bold' }}>
																{renderMoney(
																	Math.abs(VinculadasValorRestante())
																)}
															</span>
														)}
													</span>
												</Tooltip>
											}>
											<div className='menu_top_fixed_tr'>
												<img alt='!' src={HighPriory} />
											</div>
										</OverlayTrigger>
									</MenuItem>
								) : (
									<MenuItem showWarning={true}>
										<p
											style={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
											}}
											className='menu_item_title menu_margin_b-32'>
											Vincular Faturas{' '}
										</p>
										{faturasVinculadas.length > 0 && (
											<table>
												<thead>
													<tr className=''>
														<th className='menu_item_label menu_padding_b-16'>
															Fatura
														</th>
														<th className='menu_item_label menu_padding_b-16'>
															Vencimento
														</th>
														<th className='menu_item_label float_right menu_padding_b-16'>
															Valor
														</th>
													</tr>
												</thead>
												<tbody>
													{faturasVinculadas.map((inv) => {
														return (
															<tr key={`${inv.FATURA_ID}`} className=''>
																<td className='menu_item_info_bold menu_padding_b-16 h-32px'>
																	{inv.DT_REF_EDT}{' '}
																	{parseInt(inv.FD) > 0 ? ' - ' + inv.FD : ''}
																</td>
																<td className='menu_item_info_regular menu_padding_b-16 h-32px'>
																	{inv.DT_VENCIMENTO_EDT}
																</td>
																<td className='menu_item_info_bold menu_item_info_value_container float_right menu_margin_b-16'>
																	<div className='text_container'>
																		{renderMoney(inv.C1_TOTAL_CORRIGIDO)}
																	</div>
																	<button
																		onClick={(e) => {
																			e.preventDefault();
																			removerFaturaVinculada(inv.FATURA_ID);
																		}}
																		type='button'
																		className='delete_button'>
																		-
																	</button>
																</td>
															</tr>
														);
													})}
												</tbody>
											</table>
										)}

										{faturasVinculadas.length > 0 && (
											<div className='menu_paid_total menu_margin_b-32'>
												<div className='row_container menu_margin_b-8'>
													<p>Total</p>
													<p>{renderMoney(CalcularVinculadas())}</p>
												</div>
												{VinculadasValorRestante() !== 0 && (
													<div className='row_container menu_margin_b-8'>
														<p>
															{VinculadasValorRestante() !== 0
																? VinculadasValorRestante() < 0
																	? 'Valor restante'
																	: 'Valor excedente'
																: ''}
														</p>
														<p
															style={{
																color:
																	VinculadasValorRestante() !== 0
																		? '#DC3545'
																		: '#28A745',
															}}>
															{VinculadasValorRestanteStyled()}
														</p>
													</div>
												)}
											</div>
										)}

										{clienteVinculado && (
											<form
												onSubmit={(e) => {
													e.preventDefault();

													setFaturaSearch(faturaInput);
												}}
												className='menu_input_container'>
												<input
													type='text'
													value={faturaInput}
													onChange={(e) => {
														setFaturaInput(e.target.value);
													}}
													placeholder='Buscar por fatura ou ano'
												/>
												{faturaInput.length > 0 && (
													<button
														type='button'
														onClick={(e) => {
															e.preventDefault();
															setFaturaSearch(faturaInput);
														}}
														className='menu_search_button'>
														Buscar
													</button>
												)}
											</form>
										)}
										{faturaSearch !== '' && (
											<FaturaDropdown>
												<div className='tableContainer'>
													<table>
														<thead>
															<tr className=''>
																<th className='menu_item_label menu_padding_b-16'>
																	Fatura
																</th>
																<th className='menu_item_label menu_padding_b-16'>
																	Vencimento
																</th>
																<th
																	style={{ textAlign: 'right' }}
																	className='menu_item_label menu_padding_b-16'>
																	Valor
																</th>
															</tr>
														</thead>
														<tbody>
															{invoices.map((inv) => {
																if (
																	inv.DT_REF_EDT.includes(faturaSearch) &&
																	!faturasVinculadas.find(
																		(fv) => fv.FATURA_ID === inv.FATURA_ID
																	)
																)
																	return (
																		<tr className='' key={inv.FATURA_ID}>
																			<td
																				onClick={(e) => {
																					e.preventDefault();
																					setInvoiceList(inv.FATURA_ID);
																				}}
																				style={{
																					display: 'flex',
																					alignItems: 'center',
																					cursor: 'pointer',
																				}}>
																				<div
																					className='select_button'
																					style={{
																						background:
																							selectedInvoices.includes(
																								inv.FATURA_ID
																							)
																								? '#28A745'
																								: '#FFFFFF',
																					}}>
																					<img alt='v' src={DoneWhite} />
																				</div>
																				{inv.DT_REF_EDT}{' '}
																				{parseInt(inv.FD) > 0
																					? ' - ' + inv.FD
																					: ''}
																			</td>
																			<td>{inv.DT_VENCIMENTO_EDT}</td>
																			<td>
																				{renderMoney(inv.C1_TOTAL_CORRIGIDO)}
																			</td>
																		</tr>
																	);
																return null;
															})}
														</tbody>
													</table>
												</div>
												<button
													disabled={selectedInvoices.length === 0}
													style={{
														backgroundColor:
															selectedInvoices.length === 0
																? '#f0f0f0'
																: '#28a745',
														color:
															selectedInvoices.length === 0
																? '#9f9f9f'
																: '#ffffff',
													}}
													type='button'
													className='botaoVincular'
													onClick={(e) => {
														e.preventDefault();
														setarFaturaVinculada();
													}}>
													Vincular fatura selecionada
												</button>
											</FaturaDropdown>
										)}
										<OverlayTrigger
											key={'1'}
											placement='left'
											overlay={
												<Tooltip id='menu_tool_tip'>
													<span style={{ textTransform: 'capitalize' }}>
														{FaturaVinculadaTooltipText()}
														{VinculadasValorRestante() !== 0 && (
															<span style={{ fontWeight: 'bold' }}>
																{renderMoney(
																	Math.abs(VinculadasValorRestante())
																)}
															</span>
														)}
													</span>
												</Tooltip>
											}>
											<div className='menu_top_fixed_tr'>
												<img alt='!' src={HighPriory} />
											</div>
										</OverlayTrigger>
									</MenuItem>
								)}
							</BodyMenu>
						</ModalContainer>
					</ModalMainContainer>
				</div>
			</Modal.Body>
		</Modal>
	);
}

interface MainContainerProps {
	visible?: boolean;
}

const ModalMainContainer = styled.div<MainContainerProps>`
	background: #ffffff 0% 0% no-repeat padding-box;
	box-shadow: -12px 12px 16px #00000029;
	width: 100vw;
	max-width: 730px;
	height: calc(100vh);
	transition: all 0.4s;

	opacity: ${(props) => (props.visible ? 1 : 0)};
`;

const ModalHeader = styled.div`
	background: #f6f6f6 0% 0% no-repeat padding-box;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding-top: 21px;
	padding-bottom: 21px;

	padding-left: 30px;
	padding-right: 30px;
	height: 80px;
`;

const HeaderTitle = styled.h1`
	font: normal normal 500 24px/32px Roboto;
	letter-spacing: 0px;
	color: #222222;
`;

const HeaderButton = styled.button`
	border-radius: 19px;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 38px;
	padding-left: 16px;
	padding-right: 16px;

	text-align: center;
	font: normal normal 500 16px/21px Roboto;
	letter-spacing: 0px;
	border: 0;
`;

interface ModalContainerProps {
	showScroll?: boolean;
}

const ModalContainer = styled.div<ModalContainerProps>`
	background: #ffffff 0% 0% no-repeat padding-box;
	opacity: 1;
	display: flex;
	flex-direction: row;
	height: calc(100vh - 80px - 20px);
	padding: 30px;
	padding-top: 0;
	margin-top: 20px;
	overflow-y: scroll;

	::-webkit-scrollbar {
		background: transparent;
		width: 12px;
	}

	&::-webkit-scrollbar-thumb {
		background: ${(props) =>
			props.showScroll ? 'rgba(103, 103, 103, 0.5)' : 'transparent'};
		border-radius: 20px;
		border: 2.5px solid rgba(0, 0, 0, 0);
		border-right: 5px solid rgba(0, 0, 0, 0);

		background-clip: padding-box;
		max-height: 5px;
		transition: all 1s;
	}
`;

const BodyMenu = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;

interface MenuItemProps {
	showWarning?: boolean;
	showChecked?: boolean;
}

const MenuItem = styled.div<MenuItemProps>`
	background: #f6f6f6 0% 0% no-repeat padding-box;
	border-radius: 24px;
	padding: 20px;
	margin-bottom: 15px;
	position: relative;

	input {
		outline: none;
	}

	.menu_input_container {
		background: #ffffff 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 3px 6px #00000029;
		border-radius: 19px;
		height: 38px;
		display: flex;
		flex-direction: row;
		padding-right: 0;
		align-items: center;
		padding-left: 12px;

		img {
			width: 20px;
			height: 20px;
		}

		input {
			flex: 1;
			margin: 0;
			background: transparent;
			height: 38px;
			border: 0;
		}

		.menu_search_button {
			background: #28a745 0% 0% no-repeat padding-box;
			border-radius: 19px;
			height: 38px;
			text-align: center;
			font: normal normal 500 13px/18px Roboto;
			letter-spacing: 0px;
			color: #ffffff;
			padding-left: 16px;
			padding-right: 16px;
			display: flex;
			align-items: center;
			border: 0;
		}
	}

	.float_right {
		float: right;
	}

	.table_row {
	}

	table {
		width: 100%;
		border-spacing: 16px;
	}

	.menu_gray_line {
		border-bottom: 1px solid #998f8f;
	}

	.menu_margin_b-8 {
		margin-bottom: 8px;
	}
	.menu_padding_b-8 {
		padding-bottom: 8px;
	}

	.menu_margin_b-24 {
		margin-bottom: 24px;
	}
	.menu_padding_b-24 {
		padding-bottom: 24px;
	}

	.menu_margin_b-16 {
		margin-bottom: 16px;
	}

	.menu_margin_b-32 {
		margin-bottom: 32px;
	}

	.menu_padding_b-16 {
		padding-bottom: 16px;
	}
	.menu_margin_b-2 {
		margin-bottom: 2px;
	}

	.menu_margin_b-20 {
		margin-bottom: 20px;
	}

	.menu_circle {
		display: flex;
		justify-content: center;
		align-items: center;
		background: #28a745 0% 0% no-repeat padding-box;
		border-radius: 12px;
		width: 24px;
		height: 24px;
	}

	p {
		margin: 0;
	}

	.menu_item_title {
		text-align: left;
		font: normal normal bold 16px/21px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}
	.menu_item_label {
		text-align: left;
		font: normal normal normal 11px/15px Roboto;
		letter-spacing: 0px;
		color: #676767;
		text-transform: uppercase;
	}

	.menu_item_info {
		text-align: left;
		font: normal normal 500 15px/20px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.menu_item_info_bold {
		text-align: left;
		font: normal normal 700 13px/18px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.h-32px {
		height: 32px;
	}

	.menu_item_info_value_container {
		background: #ffffff 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 3px 6px #00000029;
		border-radius: 16px;
		padding: 4px;
		height: 32px;
		width: 100%;
		display: flex;
		flex-direction: row;
		align-items: center;

		.text_container {
			flex: 1;
			text-align: right;
			padding-right: 8px;
		}

		.delete_button {
			width: 24px;
			height: 24px;
			color: #ffffff;
			background: #dc3545;
			border: 0;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.menu_item_info_regular {
		text-align: left;
		font: normal normal 400 13px/18px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.menu_item_status {
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 10px;
		font: normal normal 500 10px Roboto;
		letter-spacing: 0.5px;
		color: #ffffff;
		text-transform: uppercase;
		padding-left: 12px;
		padding-right: 12px;
	}

	.menu_item_heavy {
		text-align: right;
		font: normal normal bold 18px/24px Roboto;
		letter-spacing: 0px;
		color: #222222;
	}

	.menu_bottom_fixed_br {
		position: absolute;
		background: #28a745 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 6px 6px #00000029;
		border-radius: 24px 0px;
		bottom: 0;
		right: 0;
		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
		display: flex;
	}

	.menu_top_fixed_tr_checked {
		position: absolute;
		background: #28a745 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 6px 6px #00000029;
		border-radius: 0px 24px;
		top: 0;
		right: 0;
		display: ${(props) => (props.showChecked ? 'flex' : 'none')};

		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
	}

	.menu_top_fixed_tr {
		position: absolute;
		background: #fec12d 0% 0% no-repeat padding-box;
		box-shadow: inset 0px 6px 6px #00000029;
		border-radius: 0px 24px;
		top: 0;
		right: 0;
		display: ${(props) => (props.showWarning ? 'flex' : 'none')};

		align-items: center;
		justify-content: center;
		width: 48px;
		height: 48px;
	}

	.menu_paid_total {
		.row_container {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			font: normal normal 500 13px/18px Roboto;
			letter-spacing: 0px;
			color: #222222;
			p {
				margin: 0;
			}
		}
	}
`;

const FaturaDropdown = styled.div`
	background: #ffffff 0% 0% no-repeat padding-box;
	box-shadow: 0px 8px 16px #00000029;
	border: 1px solid #ebebeb;
	border-radius: 19px;
	padding-right: 16px;
	padding-left: 16px;
	padding-bottom: 21px;
	padding-top: 12px;
	position: absolute;
	transform: translate(-20px, 5px);
	width: 100%;

	.tableContainer {
		max-height: 150px;
		overflow-y: scroll;
		::-webkit-scrollbar {
			width: 0px;
		}
	}

	.botaoVincular {
		border: 0;
		background: #28a745 0% 0% no-repeat padding-box;
		border-radius: 19px;
		height: 38px;
		font: normal normal 500 13px/18px Roboto;
		letter-spacing: 0px;
		color: #ffffff;
		width: 100%;
		margin-top: 24px;
	}

	table {
		thead {
			tr {
				th {
					font: normal normal normal 9px/11px Roboto;
					letter-spacing: 0px;
					color: #676767;
					text-transform: uppercase;
					position: -webkit-sticky; /* Safari */
					position: sticky;
					top: 0;
					background: #ffffff;
				}
			}
		}
		tbody {
			tr {
				td {
					font: normal normal normal 13px/24px Roboto;
					letter-spacing: 0px;
					color: #212529;

					.select_button {
						background: #ffffff 0% 0% no-repeat padding-box;
						border: 1px solid #b7b7b7;
						border-radius: 3px;
						width: 14px;
						height: 14px;
						margin-right: 4px;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 10px;
							height: 10px;
						}
					}
				}
			}
		}
	}
`;
